// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:34:26

export default {
  "id": "superwings-subway",
  "slug": "superwings-subway",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/64761e3485df4b4081e49666ba3b8d4b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/64761e3485df4b4081e49666ba3b8d4b/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Superwings Subway",
      "description": "Explore with ASTRA:\nCross the space dodging all kinds of obstacles with Astra. Move along three rails dodging, jumping or passing under all kinds of traps and avoid meteorites.\nBe careful, the rails are incomplete and you can fall into the void.\n",
      "instructions": "Use your mouse or finger to move in any direction, jump or crouch.",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "kidgames"
      ]
    },
    "zh-CN": {
      "title": "超级翅膀地铁",
      "description": "探索ASTRA：\n与Astra一起穿越太空，躲避各种障碍。沿着三条轨道移动，避开、跳跃或从各种陷阱下穿过，并避开陨石。\n小心，轨道不完整，你可能会掉入虚空。",
      "instructions": "使用鼠标或手指在任意方向移动，跳跃或蹲下。",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "儿童游戏"
      ]
    },
    "zh-TW": {
      "title": "超翼地鐵",
      "description": "探索ASTRA：\n與Astra一起穿越太空，避開各種障礙。沿著三條鐵軌移動，避開、跳躍或穿過各種陷阱，並避開流星。小心，鐵軌不完整，你可能會掉進虛空。",
      "instructions": "使用您的滑鼠或手指在任一方向移動、跳躍或蹲下。",
      "genres": [
        "休閒",
        "賽車與駕駛"
      ],
      "tags": [
        "兒童遊戲"
      ]
    },
    "zh-HK": {
      "title": "超翼地鐵",
      "description": "探索ASTRA：\n與Astra穿梭空間，避開各種障礙。沿著三條軌道移動，避開、跳躍或穿過各種陷阱，並避開流星。小心，軌道不完整，你可能會墮入虛空。",
      "instructions": "使用滑鼠或手指在任何方向移動、跳躍或蹲下。",
      "genres": [
        "休闲",
        "賽車及駕駛"
      ],
      "tags": [
        "兒童遊戲"
      ]
    },
    "ja": {
      "title": "スーパーウィングス・サブウェイ",
      "description": "ASTRAで探検しましょう：\nAstraを使って、さまざまな障害物を避けながら宇宙を渡りましょう。三つのレールを進みながら、トラップを避け、ジャンプしたり、下を通り抜けたりして、隕石を避けましょう。\n気をつけてください、レールは不完全で、空間に落ちてしまうかもしれません。",
      "instructions": "マウスや指を使ってどの方向にも移動し、ジャンプしたりしゃがんだりしてください。",
      "genres": [
        "カジュアル",
        "レース＆ドライビング"
      ],
      "tags": [
        "キッドゲームズ"
      ]
    },
    "ko": {
      "title": "슈퍼링스 서브웨이",
      "description": "ASTRA로 탐험하세요:\nAstra를 통해 다양한 장애물을 피하고 공간을横断하세요. 세 개의 라일을 따라 이동하면서 모든 유형의机关을 피하고, 점프하거나 아래로 통과하며 천체를 피하세요.\n주의하세요, 라일은 불완전하며 공허한 곳에 빠질 수 있습니다.",
      "instructions": "마우스나 손가락으로 어떤 방향으로든 움직이거나 점프하거나 숨기세요.",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "키드게임즈"
      ]
    },
    "fr": {
      "title": "SuperAiles Météo",
      "description": "Explorez avec ASTRA :\nTraversez l'espace en évitant toutes sortes d'obstacles avec Astra. Avancez sur trois rails en évitant, sautant ou passant sous toutes sortes de pièges et évitez les météorites.\nFaites attention, les rails sont incomplets et vous pouvez tomber dans le vide.",
      "instructions": "Utilisez votre souris ou votre doigt pour vous déplacer dans n'importe quelle direction, sauter ou vous accroupir.",
      "genres": [
        "Occasionnel",
        "Courses et Conduite"
      ],
      "tags": [
        "Jeux pour enfants"
      ]
    }
  }
};
